import Campaign from '@/models/Campaign';
import _api from '../_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    campaigns: [],
    pageCount: 0,
    totalCount: 0,
    productCategories: [],
  },
  // -----------------------------------------------------------------
  getters: {
    all: (state,) => state.campaigns,
    pageCount: (state,) => state.pageCount,
    totalCount: (state,) => state.totalCount,
    productCategories: (state,) => state.productCategories,
  },
  // -----------------------------------------------------------------
  mutations: {
    setCampaigns: (state, campaigns,) => (state.campaigns = campaigns),
    setPageCount: (state, pageCount,) => (state.pageCount = pageCount),
    setTotalCount: (state, totalCount,) => (state.totalCount = totalCount),
    setProductCategories: (state, categories,) => (state.productCategories = categories),
  },
  // -----------------------------------------------------------------
  actions: {
    get: (
      { commit, },
      {page, _id, name, enabled, type, campaignType,},) => {  
      commit('campaigns/setCampaigns', [], { root: true, },);

      return _api.get({page, _id, name, enabled, type, campaignType,},).
        then((response,) => {
          const campaings = response.data.campaigns.map(
            (campaign,) => new Campaign(campaign,),);
          commit('campaigns/setCampaigns', campaings, { root: true, },);
          commit(
            'campaigns/setPageCount',
            Math.ceil(response.data.total_count / response.data.size,),
            { root: true, },
          );
          commit(
            'campaigns/setTotalCount', response.data.total_count, {
              root: true,
            },);

          return campaings;
        },
        (error,) => {
          if (error?.response?.status === 404) {
            return error;
          }

          return _api.handleError(error,);
        },);
    },

    async getProductCategories ({ commit, },) {
      try {
        const response = await _api.getProductCategories();
        commit('setProductCategories', response.data,);
      } catch (error) {
        return await _api.handleError(error,);
      }
    },

    create: async (_, value,) => {
      const campaign = new Campaign(value,).toPost;

      return new Promise((resolve, reject,) => {
        _api.
          post(campaign,).
          then(() => {
            resolve();
          },).
          catch((error,) => {
            reject(error.response.data.errors,);
          },);
      },);
    },

    remove (_, _id,) {
      return _api.removeCampaign(_id,);
    },

    enable (_, _id,) {
      return new Promise((resolve, reject,) => {
        _api.enable(_id,).
          then(() => {
            resolve();
          },).
          catch((error,) => {
            reject(error.response.data.errors,);
          },);
      },);
    },

    disable (_, _id,) {
      return new Promise((resolve, reject,) => {
        _api.disable(_id,).
          then(() => {
            resolve();
          },).
          catch((error,) => {
            reject(error.response.data.errors,);
          },);
      },);
    },
  },
};
